import { ThumbsUp, Lightbulb, Star, Heart, CircleHelp, TriangleAlert } from "lucide-react";

// Los valores hex corresponden a la paleta de colores de Semantic UI
// (mismos tonos que usan los <Button>/<Label> color="...") para que los
// íconos de lucide-react calcen exactamente con el color del botón.
export const REACTION_TYPES = [
  { type: "useful", icon: ThumbsUp, label: "Útil", color: "blue", hex: "#2185D0" },
  { type: "insightful", icon: Lightbulb, label: "Bien explicado", color: "yellow", hex: "#FBBD08" },
  { type: "excellent", icon: Star, label: "Excelente", color: "orange", hex: "#F2711C" },
  { type: "love", icon: Heart, label: "Me encanta", color: "red", hex: "#DB2828" },
  { type: "confused", icon: CircleHelp, label: "No quedó claro", color: "teal", hex: "#00B5AD" },
  { type: "review", icon: TriangleAlert, label: "Necesita revisión", color: "brown", hex: "#A5673F" },
];

export const getReactionByType = (type) =>
  REACTION_TYPES.find((reaction) => reaction.type === type);
